<template>
  <div class="item-more">
    <i class="el-icon-right"></i>
  </div>
</template>

<script>
export default {
  name: "RipeavRightGo",
  props:{
    Link:{

    }
  }

}
</script>

<style lang="less" scoped>
.item-more{
  position: absolute;
  right: 12%;
  top: 9vh;
  z-index: 888;
  &:hover{
    i{
      color: #188ACB;
      border: 1px solid #188ACB;
    }
  }

  i{
    font-size: 32px;
    border-radius: 50px;
    display: block;
    border: 1px solid lightgray;
    color: lightgray;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
}
</style>